// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes Modal_modalOpen__hwIOw {
    0% {
        opacity: 0;
        transform: translateY(100%);
    }
    90% {
        opacity: 0.9;
        transform: translateY(-40px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes Modal_modalClose__Oi6d6 {
    0% {
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateY(100%);
    }
}

@media only screen and (max-width: 1299px) {
    .Modal_wrap__1XW1D {
        width: 100vw;
        animation-fill-mode: both;
        position: fixed;
        z-index: 9999;
        background-color: #FFFFFF;
        padding: 100px 20px 86px;
        overflow-x: hidden;
        top: 0;
        height: 100%;
        overflow-y: auto;
    }
    
    .Modal_open__K9L-v {
        animation: Modal_modalOpen__hwIOw 0.5s ease-in-out;
    }
    
    .Modal_close__ODajB {
        animation: Modal_modalClose__Oi6d6 0.5s ease-in-out;
    }
    
    .Modal_containerTop__y1VsX {
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        position: relative;
    }
    
    .Modal_imgContainer__H3y7Q {
        width: 208px;
    }
    
    .Modal_imgContainer__H3y7Q > img {
        width: inherit;
        display: block;
    }

    .Modal_infoContainer__AUNc5 {
        display: flex;
        flex-flow: column;
        justify-content: center;
        flex-shrink: 0;
    }
    
    .Modal_infoContainer__AUNc5 > span {
        display: block;
        text-align: right;
    }
    
    .Modal_infoEname__yt0h3 {
        color: #A2A2A2;
        font-size: 12px;
        font-weight: 500;   
        opacity: 1;
    }
    
    .Modal_infoEname__yt0h3.Modal_hide__Uwujq {
        visibility: hidden;
    }
    
    .Modal_infoKname__JTPja {
        color: #222222;
        font-size: 20px;
        font-weight: bold;
        margin: 0 0 14px;
    }
    
    .Modal_infoBirth__dfRNL {
        color: #222222;
        font-size: 12px;
    }
    
    .Modal_infoHr__er1M2 {
        position: absolute;
        width: calc(100vw - 200px);
        border: none;
        height: 0;
        border-top: 1px solid #DC140A;
        top: 51%;
        transform: translateY(-51%);
        right: 0;
    }
    
    .Modal_exit__xFj0V {
        position: absolute;
        right: 0;
        top: -70px;
        cursor: pointer;
        width: 28px;
    }
    
    .Modal_containerMiddle__EG0vN {
        margin: 20px 0 40px;
        padding: 0 calc((100vw - 1317px) / 2);
        display: flex;
        gap: 20px;
        overflow-x: scroll;
    }
    
    .Modal_containerMiddle__EG0vN::-webkit-scrollbar {
        display: none;
    }
    
    .Modal_imgItem__HdSn0 {
        width: 100px;
        height: 100px;
        flex-shrink: 0;
        cursor: pointer;
        overflow: hidden;
        position: relative;
    }
    
    .Modal_imgItem__HdSn0.Modal_selected__oHX\\+w {
        border: 2px solid #DC140A;
    }
    
    .Modal_imgItem__HdSn0 > img {
        width: inherit;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    
    .Modal_careerContainer__UngYf {
        width: 100vw;
        margin: 0 auto;
        display: grid;
        grid-template-columns: repeat(auto-fill, 320px);
        grid-auto-rows: 1px;
    }
    
    .Modal_careerItem__-GIzW {
        display: flex;
        flex-flow: column;
        gap: 16px;
        width: 320px;
    }
    
    .Modal_careerTheme__Lnx9j {
        display: flex;
        gap: 6px;
        align-items: center;
    }
    
    .Modal_careerTheme__Lnx9j > span {
        font-size: 20px;
        font-weight: 500;
        color: #222222
    }
    
    .Modal_careerCount__Bf3he {
        min-width: 33px;
        display: flex;
        justify-content: center;
        padding: 4px 10px;
        background-color: #DC140A;
        border-radius: 16px;
        color: #FFFFFF;
        font-size: 12px;
    }
    
    .Modal_careerContent__4Hxg6 {
        font-size: 12px;
        color: #434343;
        line-height: 20px;
    }
    
    .Modal_careerContent__4Hxg6 > span {
        display: block;
    }
}

@media only screen and (min-width: 1300px) {
    .Modal_wrap__1XW1D {
        width: 100%;
        animation-fill-mode: both;
        position: fixed;
        z-index: 9999;
        background-color: #FFFFFF;
        padding: 120px 0 240px;
        overflow-x: hidden;
        top: 0;
        height: 100%;
        overflow-y: auto;
    }
    
    .Modal_open__K9L-v {
        animation: Modal_modalOpen__hwIOw 0.5s ease-in-out;
    }
    
    .Modal_close__ODajB {
        animation: Modal_modalClose__Oi6d6 0.5s ease-in-out;
    }
    
    .Modal_containerTop__y1VsX {
        width: 1300px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        position: relative;
    }
    
    .Modal_imgContainer__H3y7Q {
        width: 640px;
        height: 960px;
    }
    
    .Modal_imgContainer__H3y7Q > img {
        width: inherit;
    }

    .Modal_infoContainer__AUNc5 {
        display: flex;
        flex-flow: column;
        justify-content: center;
    }
    
    .Modal_infoContainer__AUNc5 > span {
        display: block;
        text-align: right;
    }
    
    .Modal_infoEname__yt0h3 {
        color: #434343;
        font-size: 24px;
        font-weight: 500;   
        opacity: 0.47;
    }
    
    .Modal_infoEname__yt0h3.Modal_hide__Uwujq {
        visibility: hidden;
    }
    
    .Modal_infoKname__JTPja {
        color: #222222;
        font-size: 56px;
        font-weight: bold;
        margin: 4px 0 24px;
    }
    
    .Modal_infoBirth__dfRNL {
        color: #222222;
        font-size: 24px;
    }
    
    .Modal_infoHr__er1M2 {
        position: absolute;
        width: 750px;
        border: none;
        height: 0;
        border-top: 1px solid #DC140A;
        top: 53%;
        transform: translateY(-53%);
        right: 0;
    }
    
    .Modal_exit__xFj0V {
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
    }
    
    .Modal_containerMiddle__EG0vN {
        margin: 80px 0 82px;
        padding: 0 calc((100vw - 1317px) / 2);
        display: flex;
        gap: 80px;
        overflow-x: scroll;
    }
    
    .Modal_containerMiddle__EG0vN::-webkit-scrollbar {
        display: none;
    }
    
    .Modal_imgItem__HdSn0 {
        width: 280px;
        height: 280px;
        flex-shrink: 0;
        cursor: pointer;
        overflow: hidden;
        position: relative;
    }
    
    .Modal_imgItem__HdSn0.Modal_selected__oHX\\+w {
        border: 2px solid #DC140A;
    }
    
    .Modal_imgItem__HdSn0 > img {
        width: inherit;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    
    .Modal_careerContainer__UngYf {
        width: 1300px;
        margin: 0 auto;
        display: grid;
        grid-template-columns: repeat(auto-fill, 400px);
        grid-auto-rows: 1px;
    }
    
    .Modal_careerItem__-GIzW {
        display: flex;
        flex-flow: column;
        gap: 28px;
        width: 400px;
    }

    .Modal_careerTheme__Lnx9j {
        display: flex;
        gap: 6px;
        align-items: center;
    }
    
    .Modal_careerTheme__Lnx9j > span {
        font-size: 34px;
        font-weight: 500;
        color: #222222
    }
    
    .Modal_careerCount__Bf3he {
        min-width: 43px;
        display: inline-block;
        padding: 4px 16px;
        background-color: #DC140A;
        border-radius: 16px;
        color: #FFFFFF;
        font-size: 20px;
    }
    
    .Modal_careerContent__4Hxg6 {
        font-size: 26px;
        color: #434343;
        line-height: 44px;
    }
    
    .Modal_careerContent__4Hxg6 > span {
        display: block;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/Modal.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,YAAY;QACZ,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;MACE,UAAU;MACV,wBAAwB;IAC1B;IACA;MACE,UAAU;MACV,2BAA2B;IAC7B;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,yBAAyB;QACzB,eAAe;QACf,aAAa;QACb,yBAAyB;QACzB,wBAAwB;QACxB,kBAAkB;QAClB,MAAM;QACN,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,kDAAqC;IACzC;;IAEA;QACI,mDAAsC;IAC1C;;IAEA;QACI,cAAc;QACd,aAAa;QACb,8BAA8B;QAC9B,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,uBAAuB;QACvB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,0BAA0B;QAC1B,YAAY;QACZ,SAAS;QACT,6BAA6B;QAC7B,QAAQ;QACR,2BAA2B;QAC3B,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,eAAe;QACf,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,qCAAqC;QACrC,aAAa;QACb,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gCAAgC;IACpC;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,aAAa;QACb,+CAA+C;QAC/C,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,SAAS;QACT,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,aAAa;QACb,uBAAuB;QACvB,iBAAiB;QACjB,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,yBAAyB;QACzB,eAAe;QACf,aAAa;QACb,yBAAyB;QACzB,sBAAsB;QACtB,kBAAkB;QAClB,MAAM;QACN,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,kDAAqC;IACzC;;IAEA;QACI,mDAAsC;IAC1C;;IAEA;QACI,aAAa;QACb,cAAc;QACd,aAAa;QACb,8BAA8B;QAC9B,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,SAAS;QACT,6BAA6B;QAC7B,QAAQ;QACR,2BAA2B;QAC3B,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,MAAM;QACN,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,qCAAqC;QACrC,aAAa;QACb,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gCAAgC;IACpC;;IAEA;QACI,aAAa;QACb,cAAc;QACd,aAAa;QACb,+CAA+C;QAC/C,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,SAAS;QACT,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,qBAAqB;QACrB,iBAAiB;QACjB,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["@keyframes modalOpen {\n    0% {\n        opacity: 0;\n        transform: translateY(100%);\n    }\n    90% {\n        opacity: 0.9;\n        transform: translateY(-40px);\n    }\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes modalClose {\n    0% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n    100% {\n      opacity: 0;\n      transform: translateY(100%);\n    }\n}\n\n@media only screen and (max-width: 1299px) {\n    .wrap {\n        width: 100vw;\n        animation-fill-mode: both;\n        position: fixed;\n        z-index: 9999;\n        background-color: #FFFFFF;\n        padding: 100px 20px 86px;\n        overflow-x: hidden;\n        top: 0;\n        height: 100%;\n        overflow-y: auto;\n    }\n    \n    .open {\n        animation: modalOpen 0.5s ease-in-out;\n    }\n    \n    .close {\n        animation: modalClose 0.5s ease-in-out;\n    }\n    \n    .containerTop {\n        margin: 0 auto;\n        display: flex;\n        justify-content: space-between;\n        position: relative;\n    }\n    \n    .imgContainer {\n        width: 208px;\n    }\n    \n    .imgContainer > img {\n        width: inherit;\n        display: block;\n    }\n\n    .infoContainer {\n        display: flex;\n        flex-flow: column;\n        justify-content: center;\n        flex-shrink: 0;\n    }\n    \n    .infoContainer > span {\n        display: block;\n        text-align: right;\n    }\n    \n    .infoEname {\n        color: #A2A2A2;\n        font-size: 12px;\n        font-weight: 500;   \n        opacity: 1;\n    }\n    \n    .infoEname.hide {\n        visibility: hidden;\n    }\n    \n    .infoKname {\n        color: #222222;\n        font-size: 20px;\n        font-weight: bold;\n        margin: 0 0 14px;\n    }\n    \n    .infoBirth {\n        color: #222222;\n        font-size: 12px;\n    }\n    \n    .infoHr {\n        position: absolute;\n        width: calc(100vw - 200px);\n        border: none;\n        height: 0;\n        border-top: 1px solid #DC140A;\n        top: 51%;\n        transform: translateY(-51%);\n        right: 0;\n    }\n    \n    .exit {\n        position: absolute;\n        right: 0;\n        top: -70px;\n        cursor: pointer;\n        width: 28px;\n    }\n    \n    .containerMiddle {\n        margin: 20px 0 40px;\n        padding: 0 calc((100vw - 1317px) / 2);\n        display: flex;\n        gap: 20px;\n        overflow-x: scroll;\n    }\n    \n    .containerMiddle::-webkit-scrollbar {\n        display: none;\n    }\n    \n    .imgItem {\n        width: 100px;\n        height: 100px;\n        flex-shrink: 0;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n    }\n    \n    .imgItem.selected {\n        border: 2px solid #DC140A;\n    }\n    \n    .imgItem > img {\n        width: inherit;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n    }\n    \n    .careerContainer {\n        width: 100vw;\n        margin: 0 auto;\n        display: grid;\n        grid-template-columns: repeat(auto-fill, 320px);\n        grid-auto-rows: 1px;\n    }\n    \n    .careerItem {\n        display: flex;\n        flex-flow: column;\n        gap: 16px;\n        width: 320px;\n    }\n    \n    .careerTheme {\n        display: flex;\n        gap: 6px;\n        align-items: center;\n    }\n    \n    .careerTheme > span {\n        font-size: 20px;\n        font-weight: 500;\n        color: #222222\n    }\n    \n    .careerCount {\n        min-width: 33px;\n        display: flex;\n        justify-content: center;\n        padding: 4px 10px;\n        background-color: #DC140A;\n        border-radius: 16px;\n        color: #FFFFFF;\n        font-size: 12px;\n    }\n    \n    .careerContent {\n        font-size: 12px;\n        color: #434343;\n        line-height: 20px;\n    }\n    \n    .careerContent > span {\n        display: block;\n    }\n}\n\n@media only screen and (min-width: 1300px) {\n    .wrap {\n        width: 100%;\n        animation-fill-mode: both;\n        position: fixed;\n        z-index: 9999;\n        background-color: #FFFFFF;\n        padding: 120px 0 240px;\n        overflow-x: hidden;\n        top: 0;\n        height: 100%;\n        overflow-y: auto;\n    }\n    \n    .open {\n        animation: modalOpen 0.5s ease-in-out;\n    }\n    \n    .close {\n        animation: modalClose 0.5s ease-in-out;\n    }\n    \n    .containerTop {\n        width: 1300px;\n        margin: 0 auto;\n        display: flex;\n        justify-content: space-between;\n        position: relative;\n    }\n    \n    .imgContainer {\n        width: 640px;\n        height: 960px;\n    }\n    \n    .imgContainer > img {\n        width: inherit;\n    }\n\n    .infoContainer {\n        display: flex;\n        flex-flow: column;\n        justify-content: center;\n    }\n    \n    .infoContainer > span {\n        display: block;\n        text-align: right;\n    }\n    \n    .infoEname {\n        color: #434343;\n        font-size: 24px;\n        font-weight: 500;   \n        opacity: 0.47;\n    }\n    \n    .infoEname.hide {\n        visibility: hidden;\n    }\n    \n    .infoKname {\n        color: #222222;\n        font-size: 56px;\n        font-weight: bold;\n        margin: 4px 0 24px;\n    }\n    \n    .infoBirth {\n        color: #222222;\n        font-size: 24px;\n    }\n    \n    .infoHr {\n        position: absolute;\n        width: 750px;\n        border: none;\n        height: 0;\n        border-top: 1px solid #DC140A;\n        top: 53%;\n        transform: translateY(-53%);\n        right: 0;\n    }\n    \n    .exit {\n        position: absolute;\n        right: 0;\n        top: 0;\n        cursor: pointer;\n    }\n    \n    .containerMiddle {\n        margin: 80px 0 82px;\n        padding: 0 calc((100vw - 1317px) / 2);\n        display: flex;\n        gap: 80px;\n        overflow-x: scroll;\n    }\n    \n    .containerMiddle::-webkit-scrollbar {\n        display: none;\n    }\n    \n    .imgItem {\n        width: 280px;\n        height: 280px;\n        flex-shrink: 0;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n    }\n    \n    .imgItem.selected {\n        border: 2px solid #DC140A;\n    }\n    \n    .imgItem > img {\n        width: inherit;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n    }\n    \n    .careerContainer {\n        width: 1300px;\n        margin: 0 auto;\n        display: grid;\n        grid-template-columns: repeat(auto-fill, 400px);\n        grid-auto-rows: 1px;\n    }\n    \n    .careerItem {\n        display: flex;\n        flex-flow: column;\n        gap: 28px;\n        width: 400px;\n    }\n\n    .careerTheme {\n        display: flex;\n        gap: 6px;\n        align-items: center;\n    }\n    \n    .careerTheme > span {\n        font-size: 34px;\n        font-weight: 500;\n        color: #222222\n    }\n    \n    .careerCount {\n        min-width: 43px;\n        display: inline-block;\n        padding: 4px 16px;\n        background-color: #DC140A;\n        border-radius: 16px;\n        color: #FFFFFF;\n        font-size: 20px;\n    }\n    \n    .careerContent {\n        font-size: 26px;\n        color: #434343;\n        line-height: 44px;\n    }\n    \n    .careerContent > span {\n        display: block;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Modal_wrap__1XW1D`,
	"open": `Modal_open__K9L-v`,
	"modalOpen": `Modal_modalOpen__hwIOw`,
	"close": `Modal_close__ODajB`,
	"modalClose": `Modal_modalClose__Oi6d6`,
	"containerTop": `Modal_containerTop__y1VsX`,
	"imgContainer": `Modal_imgContainer__H3y7Q`,
	"infoContainer": `Modal_infoContainer__AUNc5`,
	"infoEname": `Modal_infoEname__yt0h3`,
	"hide": `Modal_hide__Uwujq`,
	"infoKname": `Modal_infoKname__JTPja`,
	"infoBirth": `Modal_infoBirth__dfRNL`,
	"infoHr": `Modal_infoHr__er1M2`,
	"exit": `Modal_exit__xFj0V`,
	"containerMiddle": `Modal_containerMiddle__EG0vN`,
	"imgItem": `Modal_imgItem__HdSn0`,
	"selected": `Modal_selected__oHX+w`,
	"careerContainer": `Modal_careerContainer__UngYf`,
	"careerItem": `Modal_careerItem__-GIzW`,
	"careerTheme": `Modal_careerTheme__Lnx9j`,
	"careerCount": `Modal_careerCount__Bf3he`,
	"careerContent": `Modal_careerContent__4Hxg6`
};
export default ___CSS_LOADER_EXPORT___;
